<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card class="elevation-0">
        <v-card-title class="title">
          <span style="color: gray;">Никнейм:&nbsp;</span> {{ $route.params.nickname }} &nbsp;&nbsp;&nbsp;&nbsp;<span style="color: gray;">UID:&nbsp;&nbsp;</span> {{$route.params.id}}
          <v-spacer></v-spacer>
          <v-btn fab small class="grey" @click.native="exit">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="loading !== true">
          <template>
            <table><tr style='vertical-align: top; text-align: left;'>
              <td>
            Дней аккаунту: <b>{{ customer.accountceate_days != 'null' ? customer.accountceate_days : '' }}</b><br>
            Дней с первой сделки: <b>{{ customer.first_trade_days != 'null' ? customer.first_trade_days : '' }}</b><br>
            Общий торговый объем: <b>{{ customer.total_trade_amount != 'null' ? Math.round(customer.total_trade_amount ) : '' }}</b><br>
            Ордеров продажа: <b>{{ customer.total_finish_sell_count != 'null' ? customer.total_finish_sell_count : '' }}</b><br>
            Ордеров покупка: <b>{{ customer.total_finish_buy_count != 'null' ? customer.total_finish_buy_count : '' }}</b><br>
            Страна верификации: <b>{{ customer.kyc_country_code != 'null' ? customer.kyc_country_code : '' }}</b><br>
            Положительные отзывы: <b>{{ customer.good_appraise_count != 'null' ? customer.good_appraise_count : '' }}</b><br>
            Негативные отзывы: <b>{{ customer.bad_appraise_count != 'null' ? customer.bad_appraise_count : '' }}</b><br>
            Рейтинг: <b>{{ customer.good_appraise_rate != 'null' ? customer.good_appraise_rate : '' }}</b><br>
            E-mail: <b>{{ customer.email != 'null' ? customer.email : '' }}</b><br>
            Телефон: <b>{{ customer.mobile != 'null' ? customer.mobile : '' }}</b><br>
            Рейтинг за 30 дней: <b>{{ customer.recent_rate != 'null' ? customer.recent_rate : '' }}</b><br>
            Ордеров за 30 дней: <b>{{ customer.recent_finish_count != 'null' ? customer.recent_finish_count : '' }}</b><br>
            Среднее время оплаты: <b>{{ customer.average_release_time != 'null' ? customer.average_release_time : '' }}</b><br>
            Среднее время перевода: <b>{{ customer.average_transfer_time != 'null' ? customer.average_transfer_time : '' }}</b><br>
            Торговый объем за 30 дней: <b>{{ customer.recent_trade_amount != 'null' ? customer.recent_trade_amount : '' }}</b><br>
            Дата создания аккаунта: <b>{{ customer.register_time != 'null' ? time(customer.register_time) : '' }}</b><br>
            Имя: <b>{{ customer.real_name_en != 'null' ? customer.real_name_en : '' }}</b><br>
            Добавлен: <b>{{ customer.timestamp }}</b><br>
            </td>
            <td><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            Контакты:<br>
            <span >
                  <div v-for="(header, index) in JSON.parse(customer.contacts)" :key="header.text">
                    <b>{{ index }}</b> {{ time(header) }}
                  </div>
            </span>
          </td><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td>
            Последние ордера контрагента:<br>
            <tr v-for="(order, index) in orders.orders" :key="order.text">
              <td style='vertical-align: middle;'> {{ order.status==50 ? '✅' : order.status<30 ? '⏳' : order.status==30 ? '🙏' : '❌' }}</td>
              <td :style="order.side == 0 ? 'color: green;' : 'color: red;'"> &nbsp; {{ time(order.createDate/1000)}} </td>
              <td> &nbsp; {{ order.amount}} </td>
              <!--td> &nbsp; {{ order.price}} </td-->
              <td> &nbsp; {{ order.currencyId}} </td>
              <td> &nbsp; {{ order.userName}} </td>
            </tr>
          </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <td>
            <div v-if="blacklist.customer.length > 0">Блекслист телеграмм:
            <tr v-for="(report, index) in blacklist.customer">
              <td style="max-width: 100px;"> &nbsp; <b>{{ report.timestamp}}</b> </td>
              <td style="max-width: 300px;"> &nbsp; {{ report.message}} </td>
            </tr><br>
          </div>
          <div v-if="sources.appraises.length > 0">Отзывы из других источников:
            <tr v-for="(report, index) in sources.appraises">
              <td style="max-width: 90px;"> &nbsp; <b>{{ timestampToDate(report.timestamp)}}</b> </td>
              <td style="max-width: 300px; overflow-wrap: break-word;"> &nbsp; {{ report.feedback_text}}  &nbsp; {{ report.
from_username}} </td>
            </tr>
          </div>
          <div v-if="appraises.appraises.length > 0">Негативные отзывы Байбит:
            <tr v-for="(report, index) in appraises.appraises">
              <td style="max-width: 90px;"> &nbsp; <b>{{ report.timestamp}}</b> </td>
              <td style="max-width: 300px; overflow-wrap: break-word;"> &nbsp; {{ report.message}}  &nbsp; {{ report.nick_name}} </td>
            </tr>
          </div>
          </td>
        </tr>
            </table>
          </template>
        </v-card-text>
        <v-card-text v-if="loading !== true">
          {{ link }} <br><br>
        <!--button @click="copyUrl(link)" style="color: blue;">Скопировать ссылку на профиль</button-->

        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
  /* global Store */

  import { mapState, dispatch } from 'vuex'
  export default {
    props: ['dark'],
    data() {
      return {
        title: '',
        link: '',
      }
    },
    computed: {
      ...mapState('contragents', {
        customer: 'customer',
        orders: 'orders',
        appraises: 'appraises',
        sources: 'sources',
        loading: 'loading',
        mode: 'mode',
        snackbar: 'snackbar',
        notice: 'notice',
      }),
      ...mapState('blacklist', {
        blacklist: 'customer',
      }),
    },
    watch: {
      customer() {
        this.$Progress.finish();
      },
    },
    methods: {
      exit () {
        this.$router.push('/contragents')
      },
      closeSnackbar() {
        Store.commit("customers/setSnackbar", { snackbar: false });
        Store.commit("customers/setNotice", { notice: "" });
      },
      copyUrl() {
        const el = document.createElement('textarea');
        el.value = this.link;
        alert("Скопировано:\n" + this.link)
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
      },
      time(timestamp) {
        const myDate = new Date(timestamp * 1000);
        return myDate.toLocaleDateString();
      },
      timestampToDate(timestamp) {
        const date = new Date(Number(timestamp) * 1000);
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            timeZone: 'UTC',
            hour12: false
        };
        const formattedDate = date.toLocaleString('ru-RU', options);
        return formattedDate;
      }
    },
    created() {
      Store.dispatch('contragents/getCustomerById', this.$route.params.id)
      Store.dispatch('contragents/getCustomerOrders', this.$route.params.id)
      Store.dispatch('contragents/getCustomerAppraises', this.$route.params.id)
      Store.dispatch('contragents/getCustomerSourcesAppraises', this.$route.params.id)
      Store.dispatch('blacklist/getCustomerById', this.$route.params.id)

    },
//    mounted() {
//      if (this.$route.params.nick_name) {
//        this.title = this.$route.params.nick_name
//      } else {
//        this.title = this.$route.params.id
//      }
//        this.link = this.$route.params.link
//    }
  }
</script>
<style scoped>
  .break-word {
    overflow-wrap: break-word; /* Или word-wrap: break-word; */
    word-break: break-all; /* Может потребоваться для некоторых языков */
  }
</style>




// WEBPACK FOOTER //
// ContragentForm.vue?75f34e7e